import { V1 } from './net'
import { StoreThunkAction } from 'store/state'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { noop } from 'utils/noop'
import { HS_EVENT_POST_CREATED, trackHubspotEvent } from 'services/tracking/hubspot'
import { ContentType } from 'shared'

export function requeuePost(
  ids: string[],
  ppids: string[],
  postType: 'posted' | 'failed' | 'archived',
  all?: boolean,
  bucketId?: string,
  query?: string,
  types?: ContentType[],
  startDate?: string,
  endDate?: string
): StoreThunkAction<Observable<any>> {
  return (dispatch) => dispatch(V1.requeuePost(ids, ppids, postType, all, bucketId, query, types, startDate, endDate)).pipe(tap(
    () => {
      dispatch(trackHubspotEvent(HS_EVENT_POST_CREATED, { type: 'all' }))
      if (postType === 'posted') {
        dispatch(trackHubspotEvent(HS_EVENT_POST_CREATED, { type: 'history' }))
      }
    },
    (response) => {
      if (response.response?.error?.message) {
        throw new Error(response.response?.error?.message)
      }
    }))
}
